import React, { useEffect, useRef, useState } from "react";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Compares the buildId this page was served with (window.__BUILD_ID__,
// stamped by gatsby-ssr.js) against /version.json (rewritten on every
// deploy by gatsby-node.js's onPostBuild) so a visitor who has been on the
// site since before the latest deploy gets a prompt to refresh, instead of
// silently running stale JS indefinitely.
const UpdateBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const ownBuildIdRef = useRef(null);

  useEffect(() => {
    ownBuildIdRef.current = window.__BUILD_ID__;

    const checkForUpdate = async () => {
      if (!ownBuildIdRef.current) return;

      try {
        const response = await fetch("/version.json", { cache: "no-store" });
        const { buildId } = await response.json();

        if (buildId && buildId !== ownBuildIdRef.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // Offline or a transient network error - just try again next tick.
      }
    };

    checkForUpdate();
    const intervalId = setInterval(checkForUpdate, CHECK_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkForUpdate();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-4 z-50 flex justify-center px-4">
      <div className="flex items-center gap-3 rounded bg-violet px-4 py-3 text-[13px] text-white shadow-lg dark:bg-violet-strong">
        <span>Yeni bir sürüm mevcut.</span>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="font-display text-xs font-semibold uppercase tracking-wide text-gold no-underline hover:underline"
        >
          Yenile
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
